<div class="tooling-documents-step">
  <rotec-form-v2
    [form]="stepForm"
    (formChange)="stepForm = $event"
    [fields]="documentsFields"
    [model]="toolingTaskModel"
    (modelChange)="toolingTaskModelChange.emit($event)"
  ></rotec-form-v2>
</div>
